<template>
  <CSidebar
    position="fixed"
    :unfoldable="sidebarUnfoldable"
    :visible="sidebarVisible"
    @visible-change="
      (event) =>
        $store.commit({
          type: 'updateSidebarVisible',
          value: event,
        })
    "
  >
    <img src="https://woles.ptppi.co.id/api_beos/uploads/beos.png" alt="Logo" />

    <CSidebarBrand>
      <CIcon
        custom-class-name="sidebar-brand-full"
        :icon="logoNegative"
        :height="35"
      />
      <CIcon
        custom-class-name="sidebar-brand-narrow"
        :icon="sygnet"
        :height="35"
      />
    </CSidebarBrand>
    <div class="sidebar-content" style="overflow-y: auto; height: 100%">
      <AppSidebarNavAdmin v-show="role_id === '1'" />
      <AppSidebarNav v-show="role_id === '2'" />
      <AppSidebarNav v-show="role_id === '3'" />
    </div>
    <CSidebarToggler
      class="d-none d-lg-flex"
      @click="$store.commit('toggleUnfoldable')"
    />
  </CSidebar>
</template>

<script>
import { computed } from 'vue'
import { useStore } from 'vuex'
import { AppSidebarNav } from './AppSidebarNav'
import { AppSidebarNavAdmin } from './AppSidebarNavAdmin'
import { logoNegative } from '@/assets/brand/PPI-ID-Food.png'
import { sygnet } from '@/assets/brand/PPI-ID-Food.png'
export default {
  name: 'AppSidebar',
  components: {
    AppSidebarNav,
    AppSidebarNavAdmin,
  },
  data() {
    return {
      role_id: localStorage.getItem('role_id'),
    }
  },
  setup() {
    const store = useStore()
    return {
      logoNegative,
      sygnet,
      sidebarUnfoldable: computed(() => store.state.sidebarUnfoldable),
      sidebarVisible: computed(() => store.state.sidebarVisible),
    }
  },
}
</script>
